module.exports = __webpack_public_path__ + "static/media/Hand-Gel-Belgium-Getty_mobile.68a156a6.jpg";